import InlineTextInput from '@/components/ui/inline-text-input';
import { pdkAxios } from '@/lib/pdk-axios';
import type { Trade } from '@/models/types';
import { tradesStore } from '@/stores/trades-store';
import { useMutation } from '@tanstack/react-query';
import { debounce } from 'lodash';
import { useCallback, useEffect, useState } from 'react';

// TECH DEBT: consolidate mileage editors
const TradeVehicleMileageEditor = ({
  tradeId,
  initialMileage,
}: {
  tradeId: Trade['id'];
  initialMileage: number;
}) => {
  const [mileage, setMileage] = useState(initialMileage?.toString() || '');

  const updateMileageMutation = useMutation({
    onMutate: async ({ mileage }: { mileage: number }) => {
      tradesStore.updateTrade(tradeId, {
        mileage: mileage,
      });
    },
    mutationFn: async ({ mileage }: { mileage: number }) => {
      const response = await pdkAxios.post(
        `/trades/${tradeId}/mileage`,
        // /api/trades/:trade_id/mileage
        {
          mileage,
        },
      );

      return response.data;
    },
    onSuccess: () => {},
    onError: (error, variables) => {
      console.error('Error updating mileage', error, variables);
      // TODO: handle error by adding the original cdkId back to the store
    },
  });

  const handleMileageChange = useCallback(
    debounce((newMileage: number) => {
      // toast({
      //   title: 'Mileage change not implemented',
      //   description: `Mileage change is not implemented yet. ${newMileage}`,
      // });
      updateMileageMutation.mutate({
        mileage: newMileage,
      });
    }, 1000),
    [],
  );

  useEffect(() => {
    if (mileage === (initialMileage?.toString() || '')) return;

    const parsedMileage = parseInt(mileage);

    if (isNaN(parsedMileage)) return;

    handleMileageChange(parsedMileage);
  }, [mileage]);

  const onChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    if (isNaN(Number(e.target.value))) return;
    if (Number(e.target.value) == 0) {
      setMileage('');
    } else {
      setMileage(e.target.value);
    }
  }, []);

  useEffect(() => {
    setMileage(initialMileage?.toString() || '');
  }, [initialMileage]);

  return (
    <div className="flex flex-row gap-1 items-center justify-between">
      <div className="flex flex-row gap-1 items-center">
        <div className="text-sm text-gray-500 dark:text-white">Mileage</div>
      </div>
      <InlineTextInput
        value={mileage?.toString()}
        onChange={onChange}
        placeholder="Enter mileage"
        className="text-right"
        wrapperClassName="gap-1"
      />
    </div>
  );
};

export default TradeVehicleMileageEditor;
